import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Container,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import THANKU_IMG from "../../../../resources/images/thank-you.png";
const ThanksMessageScreen = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(to right, #e0f7fa, #ffffff)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
      }}
    >
      <Container maxWidth="sm">
        <Card elevation={4} sx={{ borderRadius: 4 }}>
          <CardContent sx={{ textAlign: "center", py: 3, px: 4 }}>
            <CheckCircleIcon
              sx={{ fontSize: 80, color: "success.main", mb: 2 }}
            />
            <Typography variant="h4" gutterBottom>
              Thank You!
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Your feedback is valuable to us. The ticket has been resolved
              successfully. We appreciate your time!
            </Typography>
            <Box
              component="img"
              src={THANKU_IMG}
              alt="Thank you"
              sx={{
                width: "100%",
                objectFit: "contain",
                my: 2,
              }}
            />
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default ThanksMessageScreen;
